'use strict'

angular
  .module('basalteApp')
  .service('BasSonosOAuthCheck', [
    '$rootScope',
    'STATES',
    'BAS_MODAL',
    'BAS_CURRENT_CORE',
    'CurrentBasCore',
    'BasConditionsHelper',
    'BasState',
    'BasModal',
    BasSonosOAuthCheck
  ])

/**
 * @constructor
 * @param $rootScope
 * @param STATES
 * @param BAS_MODAL
 * @param BAS_CURRENT_CORE
 * @param {CurrentBasCore} CurrentBasCore
 * @param {BasConditionsHelper} BasConditionsHelper
 * @param {BasState} BasState
 * @param {BasModal} BasModal
 */
function BasSonosOAuthCheck (
  $rootScope,
  STATES,
  BAS_MODAL,
  BAS_CURRENT_CORE,
  CurrentBasCore,
  BasConditionsHelper,
  BasState,
  BasModal
) {

  const MODAL_SHOW_DELAY_MS = 2000
  const currentBasCoreState = CurrentBasCore.get()

  let waitForSystemAndProfile
  let showModalTimeoutId = 0

  this.check = check

  init()

  function init () {

    $rootScope.$on(
      BAS_CURRENT_CORE.EVT_CORE_CORE_CONNECTED,
      _onCurrentCoreCoreConnected
    )
  }

  function check () {

    _clearWait()
    _clearShowModalTimeout()

    waitForSystemAndProfile = BasConditionsHelper.waitForEvent(
      {
        event: BAS_CURRENT_CORE.EVT_CORE_SYSTEM,
        conditionValidator: () => CurrentBasCore.get()
          .core?.core?.system.dirty === false
      },
      _check
    )
  }

  /**
   * @private
   */
  function _check () {

    if (
      currentBasCoreState.core?.core?.system.sonosAvailable &&
      currentBasCoreState.core?.core?.system.sonosAuthRequired &&
      !currentBasCoreState.core?.core?.system.sonosPaired
    ) {
      _clearShowModalTimeout()
      showModalTimeoutId = setTimeout(_showModal, MODAL_SHOW_DELAY_MS)
    }
  }

  function _clearShowModalTimeout () {

    clearTimeout(showModalTimeoutId)
    showModalTimeoutId = 0
  }

  function _showModal () {

    // Only show if connected
    if (CurrentBasCore.hasCore()) {

      BasModal.show(BAS_MODAL.T_SONOS_OAUTH)
        .then(_onModal)
    }
  }

  function _onModal (modal) {

    modal.close.then(_onModalClose)
  }

  function _onModalClose (result) {

    if (result === BAS_MODAL.C_YES) {

      BasState.go(STATES.SETTINGS_SONOS)

    } else {

      // 'Not now' -> Do nothing
    }
  }

  function _onCurrentCoreCoreConnected (
    _event,
    _basCoreContainer,
    isConnected
  ) {

    if (!isConnected) _clearShowModalTimeout()
  }

  function _clearWait () {

    if (waitForSystemAndProfile) waitForSystemAndProfile.abort()
    waitForSystemAndProfile = undefined
  }
}
